<template>
  <div>
    <v-card class="white" flat>
      <v-card-text>
        <v-row class="ml-2 mr-2">
          <v-col cols="12" class="tabsNh">
            <v-col cols="12" style="display: flex; justify-content: end;">
              <v-btn small class="btn-save" @click="openCreateDialog">
                <v-icon>mdi-plus</v-icon>
                Agregar Impresora
              </v-btn>
            </v-col>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="printers"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:item.actions="{ item }">
            <v-btn icon small class="mr-4" @click="openEditDialog(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon small class="mr-4" @click="openEditDialog(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon small @click="confirmDelete(item)">
              <v-icon color="red">mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Dialog for Create/Edit -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ isEditing ? 'Editar Impresora' : 'Agregar Impresora' }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="form.Name"
                  label="Nombre de la Impresora *"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.Host"
                  label="Host *"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.Port"
                  label="Puerto *"
                  type="number"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="savePrinter">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">Confirmar Eliminación</v-card-title>
        <v-card-text>
          ¿Estás seguro de que deseas eliminar la impresora "{{ selectedPrinter ? selectedPrinter.Name : '' }}"?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false">Cancelar</v-btn>
          <v-btn color="red darken-1" text @click="deletePrinter">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for Printer Types -->
    <v-dialog v-model="typeDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Gestionar Tipos de Impresora</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="typeDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-btn small class="btn-save mb-2" @click="openCreateTypeDialog">
            <v-icon>mdi-plus</v-icon>
            Agregar Tipo
          </v-btn>
          <v-data-table
            :headers="typeHeaders"
            :items="printerTypes"
            :loading="typeLoading"
            class="elevation-1"
          >
            <template v-slot:item.actions="{ item }">
              <v-btn icon small class="mr-2" @click="openEditTypeDialog(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon small class="mr-2" @click="openEditTypeDialog(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon small @click="confirmDeleteType(item)">
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog for Create/Edit Printer Type -->
    <v-dialog v-model="typeFormDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ isEditingType ? 'Editar Tipo de Impresora' : 'Agregar Tipo de Impresora' }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="typeForm.Name"
                  label="Nombre del Tipo *"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeTypeFormDialog">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="savePrinterType">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation for Type -->
    <v-dialog v-model="deleteTypeDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">Confirmar Eliminación</v-card-title>
        <v-card-text>
          ¿Estás seguro de que deseas eliminar el tipo "{{ selectedType ? selectedType.Name : '' }}"?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteTypeDialog = false">Cancelar</v-btn>
          <v-btn color="red darken-1" text @click="deletePrinterTypeConfirmed">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <alerts v-if="alert.show" v-on:close_alert="closeAlert" :properties="alert"></alerts>
  </div>
</template>

<script>
import Alerts from '@/components/Alerts'

export default {
  name: 'Printers',
  components: {
    Alerts
  },
  props: ['business', 'win'],
  data() {
    return {
      printers: [],
      printerTypes: [],
      loading: false,
      dialog: false,
      deleteDialog: false,
      isEditing: false,
      selectedPrinter: null,
      form: {
        Name: '',
        ID_PrinterType: null,
        Host: '',
        Port: ''
      },
      typeDialog: false,
      typeFormDialog: false,
      deleteTypeDialog: false,
      isEditingType: false,
      selectedType: null,
      typeForm: {
        Name: ''
      },
      typeLoading: false,
      alert: {
        type: 'success',
        show: false,
        header: '',
        body: ''
      },
      headers: [
        { text: 'Nombre', value: 'Name' },
        { text: 'Host', value: 'Host' },
        { text: 'Puerto', value: 'Port' },
        { text: 'Acciones', value: 'actions', sortable: false, width: '150px' }
      ],
      typeHeaders: [
        { text: 'Nombre', value: 'Name' },
        { text: 'Acciones', value: 'actions', sortable: false, width: '120px' }
      ]
    }
  },
  mounted() {
    this.loadPrinters()
    this.loadPrinterTypes()
  },
  methods: {
    async loadPrinters() {
      this.loading = true
      try {
        const response = await this.$API.printers.getPrinters()
        this.printers = response.data || response
        console.log('Printers received:', this.printers)
      } catch (error) {
        this.showAlert('danger', 'Error', 'Error al cargar impresoras')
      } finally {
        this.loading = false
      }
    },
    async loadPrinterTypes() {
      try {
        console.log("Cargando tipos de impresora");
        
        const response = await this.$API.printers.getPrinterTypes()
        console.log("Respuesta:", response);
        this.printerTypes = response.data || response
      } catch (error) {
        this.showAlert('danger', 'Error', 'Error al cargar tipos de impresora')
      }
    },
    openCreateDialog() {
      this.isEditing = false
      this.form = { Name: '', Host: '', Port: '' }
      this.dialog = true
    },
    openEditDialog(item) {
      this.isEditing = true
      this.selectedPrinter = item
      this.form = { ...item }
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.isEditing = false
      this.selectedPrinter = null
    },
    async savePrinter() {
      if (!this.form.Name || !this.form.Host || !this.form.Port) {
        this.showAlert('warning', 'Advertencia', 'Todos los campos son requeridos')
        return
      }

      try {
        if (this.isEditing) {
          await this.$API.printers.updatePrinter(this.selectedPrinter.ID_Printer, this.form)
          this.showAlert('success', 'Éxito', 'Impresora actualizada correctamente')
        } else {
          await this.$API.printers.addPrinter(this.form)
          this.showAlert('success', 'Éxito', 'Impresora agregada correctamente')
        }
        this.closeDialog()
        this.loadPrinters()
      } catch (error) {
        this.showAlert('danger', 'Error', 'Error al guardar la impresora')
      }
    },
    confirmDelete(item) {
      this.selectedPrinter = item
      this.deleteDialog = true
    },
    async deletePrinter() {
      try {
        await this.$API.printers.deletePrinter(this.selectedPrinter.ID_Printer)
        this.showAlert('success', 'Éxito', 'Impresora eliminada correctamente')
        this.deleteDialog = false
        this.loadPrinters()
      } catch (error) {
        this.showAlert('danger', 'Error', 'Error al eliminar la impresora')
      }
    },
    showAlert(type, header, body) {
      this.alert.type = type
      this.alert.header = header
      this.alert.body = body
      this.alert.show = true
    },
    closeAlert() {
      this.alert.show = false
    },
    getTypeName(id) {
      const type = this.printerTypes.find(t => t.ID_PrinterType === id)
      return type ? type.Name : 'Desconocido'
    },
    openTypeDialog() {
      this.typeDialog = true
      this.loadPrinterTypes()
    },
    openCreateTypeDialog() {
      this.isEditingType = false
      this.typeForm = { Name: '' }
      this.typeFormDialog = true
    },
    openEditTypeDialog(item) {
      this.isEditingType = true
      this.selectedType = item
      this.typeForm = { ...item }
      this.typeFormDialog = true
    },
    closeTypeFormDialog() {
      this.typeFormDialog = false
      this.isEditingType = false
      this.selectedType = null
    },
    async savePrinterType() {
      if (!this.typeForm.Name) {
        this.showAlert('warning', 'Advertencia', 'El nombre es requerido')
        return
      }

      try {
        if (this.isEditingType) {
          await this.$API.printers.updatePrinterType(this.selectedType.ID_PrinterType, this.typeForm)
          this.showAlert('success', 'Éxito', 'Tipo de impresora actualizado correctamente')
        } else {
          await this.$API.printers.addPrinterType(this.typeForm)
          this.showAlert('success', 'Éxito', 'Tipo de impresora agregado correctamente')
        }
        this.closeTypeFormDialog()
        this.loadPrinterTypes()
      } catch (error) {
        this.showAlert('danger', 'Error', 'Error al guardar el tipo de impresora')
      }
    },
    confirmDeleteType(item) {
      this.selectedType = item
      this.deleteTypeDialog = true
    },
    async deletePrinterTypeConfirmed() {
      try {
        await this.$API.printers.deletePrinterType(this.selectedType.ID_PrinterType)
        this.showAlert('success', 'Éxito', 'Tipo de impresora eliminado correctamente')
        this.deleteTypeDialog = false
        this.loadPrinterTypes()
      } catch (error) {
        this.showAlert('danger', 'Error', 'Error al eliminar el tipo de impresora')
      }
    }
  }
}
</script>

<style scoped>
.btnsave {
  background-color: #00A178 !important;
  color: white;
}

.tabsNh {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}
</style>